import isEmpty from 'lodash/isEmpty';
import { GENERATE_MESSAGE_PREVIEW_FULFILLED } from 'store/app/entities/messages/action';
import { messagesApiUtil } from 'store/app/entities/MessagesApiSlice';

/**
 * Chat messages are rendered from RTK Query (`listMessages`), but URL preview fetch still
 * resolves through redux-promise-middleware into the legacy `messages` entity. Sync
 * fulfilled previews into the RTK cache so MessageGroup re-renders with `message.previews`.
 */
export default function linkPreviewMessagesApiSyncMiddleware({ dispatch }) {
  return next => action => {
    const result = next(action);
    if (action.type !== GENERATE_MESSAGE_PREVIEW_FULFILLED) {
      return result;
    }
    const { payload, meta } = action;
    const channelId = meta?.channel_id;
    const messageId = meta?.message_id;
    if (!channelId || !messageId || isEmpty(payload) || !payload.title) {
      return result;
    }

    dispatch(
      messagesApiUtil.updateQueryData('listMessages', { channelId }, draft => {
        if (!draft?.messages?.length) return;
        const idx = draft.messages.findIndex(m => m._id === messageId);
        if (idx < 0) return;
        const message = draft.messages[idx];

        draft.messages[idx] = {
          ...message,
          previews: {
            ...message.previews,
            [meta.link]: {
              ...payload,
              link: meta.link,
              favicon: payload.image,
            },
          },
        };
      }),
    );

    return result;
  };
}
